import {types} from './types';

export function menuOpen(data) {
  return {
    type: types.MENU_OPEN,
    payload: data,
  };
}
